import { cn } from "@/lib/utils/utils";
import React, { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div className={cn("w-full mx-auto max-w-360", className)}>{children}</div>
  );
};

export default Container;
